import React, { useState } from 'react';
import axios from 'axios';
import { FaTimes, FaCopy, FaCheck, FaShare } from 'react-icons/fa';
import '../styles/ShareModal.css';

function ShareModal({ item, onClose }) {
  const [shareUrl, setShareUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);
  const [expiresIn, setExpiresIn] = useState(7);
  const [maxPlays, setMaxPlays] = useState(0);

  const createShareLink = async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = {
        expiresInDays: expiresIn,
        maxPlays: maxPlays > 0 ? maxPlays : null
      };

      if (item.type === 'track') {
        payload.trackId = item.trackId;
      } else if (item.type === 'album') {
        payload.albumId = item.albumId;
      }

      const response = await axios.post('/api/share/create', payload);
      setShareUrl(response.data.shareUrl);
    } catch (err) {
      setError('Erreur lors de la création du lien');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textarea = document.createElement('textarea');
      textarea.value = shareUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const isAlbum = item.type === 'album';

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="share-modal-header">
          <h3><FaShare /> Partager {isAlbum ? 'un album' : 'une piste'}</h3>
          <button className="share-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="share-modal-track">
          <div className="share-modal-track-info">
            <p className="share-modal-title">
              {isAlbum ? '💿' : '🎵'} {item.title}
            </p>
            <p className="share-modal-artist">{item.artist}</p>
          </div>
        </div>

        {!shareUrl && (
          <div className="share-modal-options">
            <div className="share-option-group">
              <label>Expiration</label>
              <select value={expiresIn} onChange={(e) => setExpiresIn(parseInt(e.target.value))}>
                <option value={1}>1 jour</option>
                <option value={3}>3 jours</option>
                <option value={7}>7 jours</option>
                <option value={14}>14 jours</option>
                <option value={30}>30 jours</option>
              </select>
            </div>

            <div className="share-option-group">
              <label>Lectures max (0 = illimité)</label>
              <input
                type="number"
                min="0"
                value={maxPlays}
                onChange={(e) => setMaxPlays(parseInt(e.target.value) || 0)}
              />
            </div>

            {error && <p className="share-modal-error">{error}</p>}

            <button
              className="share-modal-btn"
              onClick={createShareLink}
              disabled={loading}
            >
              {loading ? '⏳ Création...' : '🔗 Créer le lien'}
            </button>
          </div>
        )}

        {shareUrl && (
          <div className="share-modal-result">
            <p className="share-modal-label">Lien de partage :</p>
            <div className="share-modal-url-box">
              <span className="share-modal-url">{shareUrl}</span>
              <button
                className={`share-modal-copy-btn ${copied ? 'copied' : ''}`}
                onClick={copyToClipboard}
              >
                {copied ? <FaCheck /> : <FaCopy />}
              </button>
            </div>
            {copied && <p className="share-modal-copied">✅ Copié !</p>}

            <div className="share-modal-details">
              <p>⏰ Expire dans {expiresIn} jour{expiresIn > 1 ? 's' : ''}</p>
              {maxPlays > 0 && <p>🎧 {maxPlays} lecture{maxPlays > 1 ? 's' : ''} max</p>}
            </div>

            <button
              className="share-modal-btn share-modal-btn-secondary"
              onClick={() => setShareUrl(null)}
            >
              Créer un autre lien
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ShareModal;
